export const APP_CONFIGS = {
  companyAddress: { canada: '810 - 1130 Pender St Vancouver, BC V6E 4A4' },
};
